import React, { Fragment } from 'react';
import { Container } from 'reactstrap';
import HeaderClient from '../HeaderClient';
import Footer from '../Footer';

const PrivacyPolicy = () => (
  <Fragment>
    <HeaderClient />
    <main className="page-wrapper f-bg-gray" id="pageWrapper">
      <Container className="p-t-80 p-b-80">
        <article className="bg-white p-30">
          <h1>Politique de confidentialité de l’application MaxPark</h1>
          <p><strong>Dernière mise à jour : 28 juillet 2026</strong></p>

          <p>
            Max Park Solutions exploite l’application Android MaxPark, destinée aux membres
            autorisés de son personnel. La présente politique explique quelles données sont
            traitées par l’application, pourquoi elles le sont et quels choix sont offerts aux
            utilisateurs.
          </p>

          <h2>1. Données traitées</h2>
          <ul>
            <li>
              <strong>Données de compte :</strong> adresse courriel professionnelle, identifiant
              Firebase et renseignements du profil d’agent nécessaires à l’authentification.
            </li>
            <li>
              <strong>Données opérationnelles :</strong> renseignements sur les véhicules, les
              avis de stationnement, les recherches, la création et l’impression d’avis, ainsi
              que les dates et heures associées.
            </li>
            <li>
              <strong>Photos :</strong> images prises avec la caméra et jointes à un avis de
              stationnement.
            </li>
            <li>
              <strong>Localisation :</strong> position approximative ou précise, y compris en
              arrière-plan lorsque cette autorisation est accordée, ainsi que les événements de
              localisation liés à l’ouverture de l’application, aux recherches, à la création et
              à l’impression d’avis.
            </li>
            <li>
              <strong>Données techniques :</strong> renseignements nécessaires au fonctionnement
              de l’application, à la connexion réseau, au diagnostic local des erreurs et à la
              communication avec une imprimante Bluetooth.
            </li>
          </ul>

          <h2>2. Utilisation des données</h2>
          <p>Ces données servent exclusivement à :</p>
          <ul>
            <li>authentifier les employés autorisés et protéger l’accès à l’application;</li>
            <li>créer, rechercher, documenter et imprimer les avis de stationnement;</li>
            <li>assurer le suivi opérationnel et la sécurité des activités sur le terrain;</li>
            <li>prévenir les erreurs, soutenir les utilisateurs et améliorer la fiabilité;</li>
            <li>respecter les obligations administratives, contractuelles et légales applicables.</li>
          </ul>

          <h2>3. Services et fournisseurs</h2>
          <p>
            Les données peuvent être hébergées ou traitées par Google Firebase et Google Cloud
            (authentification, bases de données et stockage), ainsi que par les services sécurisés
            de synchronisation de Max Park Solutions. L’application peut aussi consulter le
            service public de la NHTSA pour décoder certains renseignements sur un véhicule.
            Les renseignements ne sont ni vendus ni utilisés à des fins publicitaires.
          </p>

          <h2>4. Conservation</h2>
          <p>
            Les événements de localisation sont normalement conservés pendant une période
            maximale de 90 jours, sous réserve d’une exigence légale ou d’une enquête autorisée.
            Les avis de stationnement, leurs photos et les données administratives connexes sont
            conservés pendant la durée nécessaire aux opérations, aux contestations et aux
            obligations légales de Max Park Solutions, puis supprimés ou anonymisés de façon
            sécuritaire.
          </p>

          <h2>5. Autorisations et choix</h2>
          <p>
            Android demande séparément les autorisations de caméra, de localisation, de
            notifications et de Bluetooth. Elles peuvent être modifiées dans les paramètres de
            l’appareil. Le refus ou le retrait d’une autorisation peut empêcher certaines
            fonctions, notamment la prise de photos, l’impression ou le suivi des activités sur le
            terrain. Le suivi en arrière-plan n’est effectué que lorsque l’autorisation
            correspondante a été accordée.
          </p>

          <h2>6. Sécurité</h2>
          <p>
            Max Park Solutions applique des mesures administratives et techniques raisonnables,
            notamment l’authentification, le contrôle des accès et le chiffrement des communications,
            afin de protéger les renseignements contre l’accès, l’utilisation ou la divulgation
            non autorisés.
          </p>

          <h2>7. Accès, rectification et suppression</h2>
          <p>
            Un utilisateur peut demander l’accès à ses renseignements personnels, leur
            rectification ou leur suppression, sous réserve des obligations légales et
            opérationnelles applicables. Il peut également retirer les autorisations de
            l’application dans les paramètres Android.
          </p>

          <h2>8. Nous joindre</h2>
          <p>
            Pour toute question ou demande relative à la confidentialité, utilisez notre{' '}
            <a href="/contact">formulaire de contact</a> ou écrivez à :
          </p>
          <address>
            Max Park Solutions<br />
            1555, boulevard de l’Avenir, bureau 306<br />
            Laval (Québec) H7S 2N5, Canada<br />
            Téléphone : 450 634-1808
          </address>

          <h2>9. Modifications</h2>
          <p>
            Cette politique peut être mise à jour pour refléter des changements à l’application,
            à nos pratiques ou aux exigences légales. La date de la version la plus récente figure
            au début de cette page.
          </p>
        </article>
      </Container>
    </main>
    <Footer />
  </Fragment>
);

export default PrivacyPolicy;
